import ShowCard from "./ShowCard";

export default ShowCard;
